export const getDomain = () => {
  const host = window.location.hostname;
  const parts = host.split('.');

  let result = host;

  if (parts.length > 2) {
    result = '.' + parts.slice(1).join('.');
  }

  return result;
};
